export default __webpack_public_path__ + "static/media/Buy.bd01121e.svg";